export default "__VITE_ASSET__CbAlQBLG__"